"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const ButtonStyle_1 = tslib_1.__importDefault(require("../buttons/ButtonStyle"));
const PopupDialogKind_1 = tslib_1.__importDefault(require("./PopupDialogKind"));
const StyledButton_1 = tslib_1.__importDefault(require("../buttons/StyledButton"));
/**
 * TODO: Refactor this into being dialogContent in the long run
 * Class with static methods for displaying various kinds of message boxes.
 */
class PopupDialog {
    static confirmYesNo(title, text) {
        return PopupDialog.displayYesNo(PopupDialogKind_1.default.SIDE_DIALOG, title, text);
    }
    /**
     * @deprecated Be explicit about the yes/no text, use displayConfirmCancel instead
     * @param dialogKind
     * @param title
     * @param message
     */
    static async displayYesNo(dialogKind, title, message) {
        let selectedOption = await PopupDialog.display(dialogKind, title, message, PopupDialog.NO, PopupDialog.YES);
        return selectedOption === PopupDialog.YES;
    }
    static async displayConfirmCancel(dialogKind, title, message, cancelText, confirmText) {
        const cancelOption = { buttonStyle: ButtonStyle_1.default.DEFAULT, text: cancelText, isClose: true };
        const confirmOption = { buttonStyle: ButtonStyle_1.default.SECONDARY, text: confirmText, isClose: false };
        const selectedOption = await PopupDialog.display(dialogKind, title, message, cancelOption, confirmOption);
        return selectedOption === confirmOption;
    }
    static display(dialogKind, title, message, ...options) {
        return new PopupDialog({ dialogKind, title, message, options }).show();
    }
    static displayAdvanced(popupDialogArgs) {
        return new PopupDialog(popupDialogArgs).show();
    }
    static info(title, text1) {
        PopupDialog.display(PopupDialogKind_1.default.INFO, title, text1, {
            buttonStyle: ButtonStyle_1.default.DEFAULT,
            isClose: true,
            text: "Luk"
        });
    }
    static warning(title, text1) {
        PopupDialog.display(PopupDialogKind_1.default.WARNING, title, text1, {
            buttonStyle: ButtonStyle_1.default.DEFAULT,
            isClose: true,
            text: "Luk"
        });
    }
    static error(title, text1) {
        PopupDialog.display(PopupDialogKind_1.default.ERROR, title, text1, {
            buttonStyle: ButtonStyle_1.default.DEFAULT,
            isClose: true,
            text: "Luk"
        });
    }
    static prepareTemplate(dialogKind, title, text) {
        if (dialogKind == null) {
            dialogKind = PopupDialogKind_1.default.WARNING;
        }
        if (text == null) {
            text = "";
        }
        else {
            text = text.replace(/{/g, "&#123;");
        }
        const map = { "style": dialogKind, "title": title, "text": text };
        return PopupDialog.template.apply(map, false);
    }
    constructor({ dialogKind, title, message, options, showDialogOptions = {} }) {
        this.options = options;
        this.customOptions = {
            title: title,
            titleClass: dialogKind
        };
        Object.assign(this.customOptions, showDialogOptions);
        const moduleContext = fmko_ts_common_1.ModuleRegistryFactory.getModuleContext();
        const template = PopupDialog.prepareTemplate(dialogKind, title, message);
        if (!showDialogOptions.supportLabel && dialogKind === PopupDialogKind_1.default.WARNING) {
            this.customOptions.supportLabel = `${moduleContext.getModuleName()} ${(0, fmko_ts_common_1.formatDateTime)(new Date())}`;
        }
        if (moduleContext != null) {
            this.dialog = moduleContext.openDialog(template, this);
        }
        else {
            window.alert(`Kunne ikke åbne standard dialogboks for at vise følgende besked:\n\n${title}\n\n${message}`);
        }
    }
    replaceWidgets(dialog) {
        const confirmButtons = [];
        const allButtons = [];
        const reversedOptions = this.options.reverse();
        for (let i = 0; i < reversedOptions.length; i++) {
            const option = reversedOptions[i];
            const button = new StyledButton_1.default(option.buttonStyle, option.text);
            if (option.isClose) {
                this.customOptions.closeButton = button;
            }
            else {
                button.addClickHandler(() => {
                    dialog.hide();
                });
                confirmButtons.push(button);
            }
            allButtons.push(button);
        }
        this.customOptions.buttons = confirmButtons;
        // Make sure synchronous code is executed before starting on Async code
        this.promise = this.addButtons(reversedOptions, allButtons);
    }
    show() {
        if (this.dialog != null) {
            this.dialog.showWithOptions(this.customOptions);
        }
        return this.promise;
    }
    hide() {
        if (this.dialog != null) {
            this.dialog.hide();
        }
    }
    addButtons(reservedOptions, allButtons) {
        return new Promise((resolve) => {
            allButtons
                .forEach((button, index) => {
                const reversedOption = reservedOptions[index];
                button.addClickHandler(() => {
                    resolve(reversedOption);
                });
            });
        });
    }
}
PopupDialog.YES = { buttonStyle: ButtonStyle_1.default.SECONDARY, text: "Ja", isClose: false };
PopupDialog.NO = { buttonStyle: ButtonStyle_1.default.DEFAULT, text: "Nej", isClose: true };
PopupDialog.template = new fmko_ts_common_1.StringTemplate("<div class='popup-dialog-text'>{text}</div>", true);
exports.default = PopupDialog;
//# sourceMappingURL=PopupDialog.js.map